<template>
  <div id="login_dialog_outer">
    <div>
      <a class="iconfont close-button"
         href="javascript:void(null);"
         @click="$emit('close')"
      >&#xe639;</a>

      <div id="dialog_login_card">
        <div id="login_card_top_menu">
          <a v-for="(item, index) in tabList"
             href="javascript:void(0);"
             :class="[index == tabIndex ? 'active' : '']"
             @click="tabIndex = index"
             :key="'login_menu_' + index"
          >{{item}}</a>
        </div>

        <div style="width: 100%;height: 50px;display: flex;flex-direction: column;align-items: center;justify-content: center;">
<!--          <div v-if="tabIndex == 0" id="login_card_sub_menu">-->
<!--            <a v-for="(item, index) in subTabList"-->
<!--               v-if="tabIndex == 0"-->
<!--               :class="[subTabIndex == index ? 'active' : '']"-->
<!--               href="javascript:void(0);"-->
<!--               @click="subTabIndex = index"-->
<!--               :key="'login_sub_menu_' + index"-->
<!--            >{{item}}</a>-->
<!--          </div>-->
        </div>

        <div id="login_card_inputs_outer" v-if="(tabIndex == 0 && subTabIndex == 1) || tabIndex == 1">
          <el-input style="margin-top: 20px;" placeholder="请输入账户名称或者手机号" v-model="userName" clearable></el-input>
          <el-input style="margin-top: 15px;"
                    type="password"
                    placeholder="请输入密码"
                    @keyup.enter="passwordEnterKeyClicked"
                    v-model="userPwd"
                    clearable></el-input>
          <a class="link-set"
             :href="'/forgetpwd' + '/' + tabIndex"
             style="display: block;align-self: flex-end;margin-right: 10%;margin-top: 15px;">忘记密码？</a>
          <el-button
            @click="userLogin"
            style="background-color: #fc1a34;color: white; border: none;width: 50%;min-width: 150px;margin-top: 20px;" round>登录</el-button>
          <div style="margin-top: 20px;">还没有账号？<a class="link-set" href="/register">去注册</a></div>
        </div>

        <weixin-qr-code v-else-if="!this.isWeixin()"></weixin-qr-code>
        <div style="width: 250px;height: 259px;display: flex;flex-direction: column;align-items: center;justify-content: center;" v-else>
          <el-button
            @click="wechatRequestButtonClicked"
            style="background-color: #fc1a34;color: white;min-width: 150px;font-size: 1rem;" round>点击授权</el-button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import WeixinQrCode from "./WeixinQrCode";
  import WeixinManager from "../../js/weixin.config";
export default {
  name: "LoginDialog",
  components: {
    WeixinQrCode
  },
  data() {
    return {
      tabIndex: 0,
      tabList: [
        '个人登录',
        '团体登录'
      ],
      subTabIndex: 1,
      subTabList: [
        '微信登录',
        '账号密码登录',
      ],

      userName: '',
      userPwd: '',
    }
  },

  mounted() {
    this.dealWithDataInit();
  },

  computed: {
    httpManager() {
      return this.$store.state.http;
    },
    eventManager() {
      return this.$store.state.eventManager;
    },
  },
  methods: {
    wxUserLogin(code, state, callback) {
      let params = {
        code: code
      };

      if (state == 1002) {
        params.pf = 'wx';
      } else {
        params.pf = 'pc';
      }

      let _this = this;
      this.httpManager.ajax.userQrconnect(params, function (data) {
        let code = data.code;
        if (code == 0) {
          let user = data.data;
          let firstLoginByWXQR = user.firstLoginByWXQR;
          let wxUserInfoModel = user.wxUserInfoModel;
          if (firstLoginByWXQR != undefined && firstLoginByWXQR == false) {
            _this.dealWithLoginSuccess(data);
            _this.$toast('登录成功！');
            _this.changeRoutePath();
            setTimeout(function () {
              _this.$emit('close');
            }, 1000);
            return;
          } else {
            if (wxUserInfoModel != null && wxUserInfoModel.unionid != undefined && wxUserInfoModel.unionid != null) {
              callback(data);
            } else {
              _this.$toast('未查到该用户！');
              _this.changeRoutePath();
            }
            return;
          }
        }
        _this.changeRoutePath();
        _this.$toast('数据加载失败');
      }, function (data) {
        _this.$toast('数据加载失败，请刷新');
      })
    },

    changeRoutePath() {
      let id = this.$route.params.id;
      // let md = this.$route.query.md;

      let query = this.$route.query;
      let state = query.state;
      let code = query.code;
      if (state != undefined) {
        delete query.state;
      }
      if (code != undefined) {
        delete query.code;
      }

      this.$router.push({
        name: this.$route.name,
        params: {
          id
        },
        query,
      });
    },

    dealWithDataInit() {
      let query = this.$route.query;
      let state = query.state;
      let code = query.code;
      if (state != undefined || code != undefined) {
        if (code == undefined) {
          this.$toast('取消登录！');
          this.changeRoutePath();
        } else {
          let _this = this;
          this.wxUserLogin(code, state,function (data) {
            _this.changeRoutePath();
            let user = data.data;
            _this.$confirm('欢迎您首次登录，您是否要绑定已有账号？', '提示', {
              confirmButtonText: '去绑定',
              cancelButtonText: '跳过',
              type: 'warning',
            }).then(() => {
              _this.$emit('close');
              _this.$store.state.dataStore.setWeixinData(data.data);
              let newLocation = _this.$router.resolve({
                name: 'weixinLoginBind'
              });
              window.location.href = newLocation.href;
            }).catch(() => {
              _this.skipBind(user, function () {
                _this.$emit('close');
              });
            })
          });
        }
        return;
      }

    },

    skipBind(user, callback) {
      if (this.requestLoading) {
        return;
      }
      let userData = user;
      let params = {
        isTeam: 0,
        vxUnionid: userData.wxUserInfoModel.unionid,
        name: userData.wxUserInfoModel.nickname,
        headPortrait: userData.wxUserInfoModel.headimgurl,
        sex: userData.wxUserInfoModel.sex,
        vx: userData.wxUserInfoModel.nickname
      };

      let _this = this;
      this.requestLoading = true;
      this.httpManager.ajax.userLogon(params, function (data) {
        _this.requestLoading = false;
        let code = data.code;
        if (code == 0) {
          _this.dealWithLoginSuccess(data);
          callback();
          return;
        }
        _this.$toast('请求失败！');
      }, function () {
        _this.requestLoading = false;
        _this.$toast('请求失败，请重试！');
      })
    },


    passwordEnterKeyClicked() {
      let name = this.userName.removeBlanks();
      if (name == undefined || name == '') {
        return;
      }
      this.userLogin();
    },

    userLogin() {
      let name = this.userName.removeBlanks();
      if (name == undefined || name == '') {
        this.$toast('用户名不能为空');
        return;
      }

      let pwd = this.userPwd.removeBlanks();
      if (pwd == undefined || pwd == '') {
        this.$toast('密码不能为空');
        return;
      }

      let params = {
        name,
        password: pwd,
      }

      let _this = this;
      this.$store.state.http.ajax.userSignin(params,
        function (data) {
          if (data.code == 0) {
            _this.$toast('登录成功！');
            _this.dealWithLoginSuccess(data);
            _this.$emit('close');
          } else {
            _this.$toast('用户名或密码错误，请重新输入！');
          }
        }, function (data) {
          _this.$toast('登录失败，请重试！');
        });
    },

    dealWithLoginSuccess(data) {
      let user = data.data;
      let isTeam = user.isTeam;
      let token = user.token;
      let nickName = user.nickname;
      let saveUser = {
        token: token,
        isTeam: isTeam,
        nickName: nickName,
        userId: user.id
      };
      let dataManager = this.$store.state.dataStore;
      dataManager.setUser(saveUser);
      this.eventManager.postNotification(this.eventManager.notificationNameObject.UserUpdate);
    },
    wechatRequestButtonClicked() {
      let url = window.location.href;
      WeixinManager.jsapi_weixinLoginAutorize(url);
    }
  }
}
</script>

<style scoped>

  #login_dialog_outer {
    background-color: rgba(0,0,0, 0.3);
    width: 100vw;
    height: 100vh;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999;

    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
  }

  #login_dialog_outer > div {
    position: relative;
    /*width: 80%;*/
    max-width: 800px;
    min-width: 290px;
    padding-top: 40px;
    padding-bottom: 30px;
    padding-left: 15px;
    padding-right: 15px;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    border-radius: 4px;
    background-color: white;

  }

  #login_dialog_outer .close-button {
    position: absolute;
    top: 3px;
    right: 5px;
    font-size: 2rem;
    z-index: 999;
    text-decoration: none;
    color: black;
  }

  #dialog_login_card {
    overflow: hidden;
    width: 50vw;
    min-width: 270px;
    max-width: 500px;
    min-height: 300px;

    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: center;
  }

  #login_card_top_menu {
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    justify-content: flex-start;
    margin-top: 0;
    text-align: center;
  }

  #login_card_top_menu a:first-child {
    border-top-left-radius: 8px;
  }

  #login_card_top_menu a:last-child {
    border-top-right-radius: 8px;
  }

  #login_card_top_menu > a {
    width: 50%;

    border: solid 1px #fc1a34;
    background-color: transparent;
    color: black;

    vertical-align: middle;
    display: inline-block;
    line-height: 50px;
    height: 50px;
    font-weight: bold;
    font-size: 1.3rem;
    text-decoration: none;
  }

  #login_card_top_menu > a.active {
    background-color: #fc1a34;
    color: white;

    pointer-events: none;
  }

  #login_card_sub_menu {
    height: 30px;
    width: 100%;
    max-width: 400px;
    display: flex;
    flex-wrap: nowrap;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
  }

  #login_card_sub_menu a {
    color: #333;
    font-size: 0.8rem;
    text-decoration: none;
  }

  #login_card_sub_menu a.active, #login_card_sub_menu a:hover {
    color: #fc1a34;
  }

  #login_card_sub_menu a.active {
    pointer-events: none;
  }

  #login_card_inputs_outer {
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
    height: 259px;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }

  #login_card_inputs_outer .el-input {
    width: 80%;
    min-width: 250px;
    max-width: 400px;
  }

  #login_card_inputs_outer .el-input /deep/ .el-input__inner:focus {
    border: solid 1px #fc1a34;
  }

  #login_card_inputs_outer .link-set {
    text-decoration: none;
  }

  #login_card_inputs_outer .link-set:hover {
    color: #fc1a34;;
  }

</style>



// WEBPACK FOOTER //
// src/components/common/LoginDialog.vue